import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
/**
 * 插件
 * */

// 错误捕获
import pluginError from '@/plugins/error';
// 日志插件
import pluginLog from '@/plugins/log';
// 鉴权指令
import directiveAuth from '@/plugins/auth';
import loadingPlugin from '@/components/loading/loading.js';
export default {
  install: function () {
    var _install = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(Vue, options) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // 插件
            Vue.use(pluginError);
            Vue.use(pluginLog);
            Vue.use(loadingPlugin);

            // 指令
            Vue.directive('auth', directiveAuth);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function install(_x, _x2) {
      return _install.apply(this, arguments);
    }
    return install;
  }()
};